import { CONSTANTS } from "client/utils/constants";
import {HOME_ACTIVE_MENU} from 'client/utils/constants/homeGridConstants'
export const types = [CONSTANTS.TRANSFER, CONSTANTS.DISPOSITION, CONSTANTS.REACTIVATION, CONSTANTS.AFEREQUEST];

export const GetOnOrderIdClickedUrl = (orderStatus:any,requestType:any,orderId:any,isBulkOrder: boolean,pageName:any,activeMenu:any) => {
    let src = "";
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER || activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        if (types.includes(requestType)) {
            if(requestType === CONSTANTS.AFEREQUEST){
                src = '/ordermanagement/afeorderapproval/' + orderId + '/' + requestType;
            }else{
                src = '/ordermanagement/assetorderapproval/' + orderId;
            }
        } else if(isBulkOrder){
            src = '/ordermanagement/bulkorderapproval/' + orderId    
        } else {
        src = '/ordermanagement/requisitionorderapproval/' + orderId;
        }
    }else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        if (types.includes(requestType)) {
            if(requestType === CONSTANTS.AFEREQUEST){
                src = '/ordermanagement/afeorderdetail/' + orderId + '/asset/' + requestType;
            }else{
                src = '/ordermanagement/fleetprocessingasset/' + orderId + '/' + pageName + '/' + requestType;
            } 
        } else if (isBulkOrder) {
            src = '/ordermanagement/fleetprocessingbulkorderdetail/' + orderId + '/' + pageName;
        } else {
            src = '/ordermanagement/fleetprocessingorderdetail/' + orderId + '/' + pageName;
        }
    }
    else {
        if (orderStatus === "Unsubmitted") {
            if (types.includes(requestType)) {
                src = '/ordermanagement/assetcreateorder/' + orderId + "/home" + '/' + requestType;
            } else if (requestType === CONSTANTS?.BULK_ORDER_GRID) {
                src = '/ordermanagement/createnewbulkorder/' + orderId + '/home';
            } else {
                src = '/ordermanagement/createorder/' + orderId + "/home";
            }
        } 
        else {
            if (types.includes(requestType)) {
                if(requestType === CONSTANTS.AFEREQUEST){
                    src = '/ordermanagement/afeorderdetail/' + orderId + '/' + pageName + '/' + requestType;
                }else{
                    src = '/ordermanagement/assetorderdetail/' + orderId + '/' + pageName;
                }
            } else if(isBulkOrder){
                src = '/ordermanagement/bulkorderdetail/' + orderId + '/' + pageName; 
            } else {
                src = '/ordermanagement/requisitionorderdetail/' + orderId + '/' + pageName;
            }    
        }
    }
    return src;
}